module.exports = __webpack_public_path__ + "static/media/fullscreen_icon.23a832d6.svg";